<form [formGroup]="openAiSettingsForm" (ngSubmit)="onSubmitOpenAiSettings()">
  <div class="form-group pt-2">
    <div class="form-group">
      <label for="llmConfigurationId">
        {{ 'Settings::LLMConfiguration:InitialAnalysis' | abpLocalization }}
      </label>
      <ca-select [class]="'below-all'" [clearable]="true" formControlName="llmConfigurationId">
        <ca-option *ngFor="let llmConfiguration of llmConfigurations" [value]="llmConfiguration.id">
          {{ llmConfiguration.name }}
        </ca-option>
      </ca-select>
    </div>
    <div class="form-group pt-2">
      <label for="keyInsightsLlmConfigurationId">
        {{ 'Settings::LLMConfiguration:KeyInsights' | abpLocalization }}
        <span class="text-muted small">
          {{ 'Settings::LLMConfiguration:Optional' | abpLocalization }}
        </span>
      </label>
      <ca-select
        [class]="'below-all'"
        [clearable]="true"
        formControlName="keyInsightsLlmConfigurationId">
        <ca-option
          *ngFor="let llmConfiguration of llmConfigurations; trackBy: trackByLlmConfigurationId"
          [value]="llmConfiguration.id">
          {{ llmConfiguration.name }}
        </ca-option>
      </ca-select>
    </div>
  </div>

  <div>
    <button type="button" type="submit" class="btn btn-primary mt-3">
      <i class="me-1 fas fa-save"></i>
      {{ 'AbpUi::Save' | abpLocalization }}
    </button>
  </div>
</form>
